/**
 * ÉLŐ KÖZVETÍTÉS — a MEZŐ-bontás átadója a rögzítő képernyő és a közvetítő
 * között.
 *
 * A cellasorsokat az élő előnézet számolja (`usePreviewEngine`), az viszont a
 * `TrackingScreen`-hez tartozik; a közvetítő (`useLivePublish`) ezzel szemben
 * a `RecorderProvider`-ben él, hogy a képernyőváltást túlélje. A kettő közt
 * ez a modulszintű érték a híd: a képernyő beírja, a közvetítő a képkocka
 * pufferelésekor kiolvassa.
 *
 * ⚠️ Ha a futó elnavigál a rögzítő képernyőről, az előnézet leáll, és itt a
 * LEGUTÓBBI érték marad. Ez szándékos: egy kicsit régebbi szám jobb, mint egy
 * nullára ugró.
 *
 * Az ELVESZTETT szám szándékosan nincs itt: azt csak a több játékost látó
 * nézőoldal tudja kiszámolni (`/live/battle`).
 */
import type { ClaimCounts } from '@/lib/previewEngine';

export interface LiveCellStats {
  /** Szabad cella, ami most lenne a tiéd. */
  cellsNew: number;
  /** Idegen cella, amit most vennél el. */
  cellsStolen: number;
  /**
   * Saját cella, amit újra bejártál. A foglalási szabály szerint ezek védelme
   * mindig legalább 2 (`game/claim.ts`: a megerősítés +1), tehát ez a „VÉDETT"
   * szám — külön küszöb nélkül.
   */
  cellsDefended: number;
}

export const EMPTY_LIVE_CELL_STATS: LiveCellStats = {
  cellsNew: 0,
  cellsStolen: 0,
  cellsDefended: 0,
};

let current: LiveCellStats = EMPTY_LIVE_CELL_STATS;

export function liveCellStatsFromCounts(counts: ClaimCounts): LiveCellStats {
  return {
    cellsNew: counts.free,
    cellsStolen: counts.stolen,
    cellsDefended: counts.reclaimed,
  };
}

export function setLiveCellStats(counts: ClaimCounts): void {
  current = liveCellStatsFromCounts(counts);
}

export function liveCellStats(): LiveCellStats {
  return current;
}

/** Új rögzítésnél az előző futás számai nem lóghatnak át. */
export function resetLiveCellStats(): void {
  current = EMPTY_LIVE_CELL_STATS;
}
